export const hiddenAdditionalParameters = [
    "etd_res_id"];

export function isHiddenAdditionalParameters(additionalParameterName){
        const result = hiddenAdditionalParameters.some(additionalParameter => additionalParameterName.toLowerCase() === additionalParameter);
        return result;
        }